document.addEventListener('DOMContentLoaded', () => {
  const initReadMore = () => {
    const readMoreContainers = document.querySelectorAll('.slideshow__text.banner__box');

    readMoreContainers.forEach((container) => {
      // Prevent re-initialization
      if (container.dataset.readMoreInitialized) {
        return;
      }
      container.dataset.readMoreInitialized = 'true';

      // The "Read More" functionality is disabled as per user request.
      // The button is no longer created and the text is not clamped.
      /*
      const content = container.querySelector('p'); // Assuming text is in a <p> tag
      if (!content) return;

      const lineHeight = parseFloat(getComputedStyle(content).lineHeight);
      const clampHeight = lineHeight * 3; // 3 lines

      // Only add "Read More" if content overflows
      if (content.scrollHeight > clampHeight) {
        container.classList.add('read-more-clamped');

        // Create and append the button
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'read-more-toggle-button link';
        button.innerText = 'הצג עוד';
        container.appendChild(button);

        // Add click event listener
        button.addEventListener('click', () => {
          container.classList.toggle('read-more-clamped');
          if (container.classList.contains('read-more-clamped')) {
            button.innerText = 'הצג עוד';
          } else {
            button.innerText = 'הצג פחות';
          }
        });
      }
      */
    });
  };

  // Run on initial load
  initReadMore();

  // Re-run when Shopify theme editor updates a section
  document.addEventListener('shopify:section:load', initReadMore);
});
